import React from 'react'
import { useAppContext } from '../../App'
import onValidate_ from './validate'
import onSubmit from './submit'
import { getState } from '../../twd'

export const Context = React.createContext()
export const initialValues = {
    holdInvType: ['C'],
    holdMaturityMin: '',
    holdMaturityMax:'',
    quantityMin: '',
    quantityMax:'',
    offerYtwMin: '',
    offerYtwMax:'',
    clientPriceMin: '',
    clientPriceMax:'',
    holdSpRatingMin:'BBB-',
    holdSpRatingMax:'AAA',
    holdMoodyRatingMin:'Baa3',
    holdMoodyRatingMax:'Aaa',
    holdRatingAndOr:'OR',
    rating:'investment-grade',
    holdCorpSectorCode: [],
    sectors:[],
}

const state = getState('corporates.quick-screener', {
    currentValues: initialValues
})

const onValidate = (values) => {
    let err = onValidate_(values)
    state.set({
        currentValues: values,
        errors: err
    })
    return err
}

export const ContextProvider = ({children}) => {
    const { ajax, Status } = useAppContext()

    return (
    <Context.Provider value={{
        state, ajax, Status, onValidate, onSubmit
    }}>
    {children}
    </Context.Provider>
    )
}

export const useQuickScreener = () => React.useContext(Context)


// WEBPACK FOOTER //
// ./src/corporates/quick-screener/use-quick-screener.js